import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import { URLString } from '/src/lib/types';

export type ListDataColumnProps = {
  /**
   * Column label
   */
  label?: string;
  /**
   * Column value
   */
  value?: string;
  /**
   * If set, displayed value is a link to the given URL
   */
  url?: URLString;
  /**
   * Element flex amount
   */
  flex?: number;
  /**
   * Text alignment
   */
  textAlign?: 'left' | 'center' | 'right';
  /**
   * Shows a placeholder if no value is set
   */
  blankPlaceholder?: string;
};

export const ListDataColumn: React.FC<ListDataColumnProps> = ({
  value,
  url,
  flex = 1,
  textAlign,
  blankPlaceholder = '',
}) => {
  /** Computed **/
  const className = textAlign ? `text-${textAlign}` : '';

  /** Render **/
  return (
    <Box
      component="span"
      display={flex ? 'flex' : undefined}
      flex={flex}
      className={className}
      maxWidth={flex && flex > 1 ? flex + '%' : undefined}
    >
      {value ? url ? <Link to={url}>{value}</Link> : value : blankPlaceholder}
    </Box>
  );
};
